import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=d5a149c4&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=d5a149c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a149c4",
  null
  
)

export default component.exports